import { changeCellStyle, excelExport } from "components/CommonLib/CommonLib";

export const exportToExcel = (data, fileName) => {
  const newData = [];
  let totalPrice = 0;
  for (let i = 0; i < data.length; i++) {
    const row = {};
    row.날짜 = changeCellStyle(data[i]?.reg_date ?? "", "", "left");
    row.지점 = changeCellStyle(data[i]?.branch_info.branch_name ?? "", "", "left");
    row.시재금입출구분 = changeCellStyle(data[i]?.vault_type ?? "", "", "left");
    row.금액 = changeCellStyle(data[i]?.price ?? "");
    row.내용 = changeCellStyle(data[i]?.note ?? "", "", "left");
    row.담당자 = changeCellStyle(data[i]?.reg_info.reg_name ?? "", "", "left");

    totalPrice += data[i]?.price;

    newData.push(row);
  }

  // 헤더 스타일 정의
  const headerStyle = {
    fill: { fgColor: { theme: 4, tint: 0.8 } },
    alignment: { horizontal: "left" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  excelExport(newData, fileName, 18, headerStyle);
};
